import Vue from "vue";
import Vuex from "vuex";

import usuarioStore from "@/store/usuario";
import candidaturaInternaStore from "@/views/candidatura-interna/candidaturainterna_store";
import notificacaoStore from "@/views/notificacoes/notificacoes_store";
import homeStore from "@/views/home/home_store";
import atestadoStore from "../views/atestados/atestados_store";
import dependentesStore from "../views/dependentes/dependentes_store";
import anexosStore from "../components/anexar-documentos/anexo_store";
import treinamentoStore from "../views/treinamentos/treinamento_store";
import atualizacaoCadastralStore from "../views/atualizacao-cadastral/atualizacao_cadastral_store";
import planoSaudeStore from "../views/plano-saude/plano_saude_store";
import indicacaoPcdStore from "../views/indicar-pcd/indicacao_pcd_store";
import planosBeneficiosStore from "../views/planos-beneficios/planos_benef_store";
import configComprasPrazoStore from "../views/config-compras-prazo/config_compras_prazo_store";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    usuario: usuarioStore,
    candidaturainterna: candidaturaInternaStore,
    notificacao: notificacaoStore,
    home: homeStore,
    atestado: atestadoStore,
    dependentes: dependentesStore,
    anexos: anexosStore,
    treinamento: treinamentoStore,
    atualizacaoCadastral: atualizacaoCadastralStore,
    planoSaude: planoSaudeStore,
    pcd: indicacaoPcdStore, 
    planosBeneficios: planosBeneficiosStore,
    configComprasPrazo: configComprasPrazoStore
  },
});
